import React from 'react'

import { AlertStrong, FormInfoAlert } from 'components/reusables/formInfoAlert'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from './common'

interface NormativeCourseEditAlertProps {
  certificateName: string
}

export const NormativeCourseEditAlert: React.FC<NormativeCourseEditAlertProps> =
  ({ certificateName }) => {
    const t = useTranslationRankmi({
      prefix: `${prefix}.normative.editAssociatedCertificateAlert`,
    })

    return (
      <FormInfoAlert>
        {t('label')}
        <AlertStrong>{certificateName}</AlertStrong>
      </FormInfoAlert>
    )
  }
